import request from '@/utils/request';

// 登录
export const login = (data) => {
  return request({  // 发起登录请求
    url: '/api/login/index',  // 请求的API端点
    method: 'post',  // 请求方法为POST
    data,  // 请求体数据
  });
};
// 验证码登录
export const codeLogin = (data) => {
  return request({
    url: '/api/login/loginbyphone',
    method: 'post',
    data,
  });
};
// 获取验证码
export function getPhoneCode(params) {
  return request({
    url: '/api/login/send',
    method: 'get',
    params,
  });
}
// 重置密码
export const resetPassword = (data) => {
  return request({
    url: '/api/login/loginbyphone',
    method: 'post',
    data,
  });
};
// 注册
export const register = (data) => {
  return request({
    url: '/api/login/add',
    method: 'post',
    data,
  });
};
// 重置密码_one
export const reset_one = (data) => {
  return request({
    url: '/api/login/checkResetSmsCode',
    method: 'post',
    data,
  });
};
// 重置密码_two
export const reset_two = (data) => {
  return request({
    url: '/api/login/updateResetPassword',
    method: 'post',
    data,
  });
};
// 退出登录
export function loginOut(params) {
  return request({
    url: '/api/login/logout',
    method: 'get',
    params,
  });
}

